@use '@/sass/variables';

.scoringScaleCell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  min-height: 23px;
  padding: variables.$spacing-extra-small variables.$spacing-small;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;

  &.readOnly {
    cursor: not-allowed;
    color: variables.$dark-gray;
    background-color: variables.$near-white;
  }
}

.scaleValue {
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 100%;
}

.scaleBadge {
  display: inline-flex;
  align-items: center;
  background-color: variables.$moon-gray;
  border-radius: 3px;
  padding: 2px 6px;
  margin: 1px;
  font-size: 12px;
  line-height: 1.2;
  color: variables.$near-black;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  justify-content: center;
  position: relative;
  gap: 2px;
  height: auto;
  max-height: 20px;

  &:hover .badgeClearButton {
    opacity: 1;
    background-color: variables.$washed-red;
  }
}

.badgeText {
  display: inline-block;
  line-height: 1;
}

.badgeClearButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: variables.$gray;
  cursor: pointer;
  padding: 0 1px;
  font-size: 11px;
  line-height: 1;
  margin: 0;
  opacity: 0.6;
  transition:
    opacity 0.2s,
    background-color 0.2s;
  flex-shrink: 0;
  min-width: 10px;
  height: 14px;
  outline: none;
  border-radius: 2px;

  &:focus {
    outline: none;
  }

  &:hover,
  &:focus-visible {
    opacity: 1;
    background-color: variables.$washed-red;
    color: variables.$red;
  }

  &:active {
    background-color: variables.$light-red;
  }
}

// Old clearButton style - no longer used
// .clearButton {}

.placeholder {
  color: variables.$silver;
  font-style: italic;
}

.scoringScaleModal {
  background: white;
  border: 1px solid variables.$moon-gray;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 16px;
  min-width: 350px;
}

.modalContent {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.header {
  font-size: 14px;
  font-weight: 600;
  color: variables.$near-black;
  padding-bottom: 8px;
  border-bottom: 1px solid variables.$light-gray;
}

.scaleTypeSelection {
  display: flex;
  gap: 24px;
  padding: 8px 0;
}

.radioLabel {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  input[type='radio'] {
    cursor: pointer;
  }

  span {
    font-size: 14px;
    color: variables.$near-black;
  }
}

.numericInputs {
  display: flex;
  gap: 16px;
  padding: 8px 0;
}

.inputGroup {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    font-size: 12px;
    color: variables.$dark-gray;
    font-weight: 500;
  }

  input[type='number'] {
    padding: 6px 8px;
    border: 1px solid variables.$moon-gray;
    border-radius: 3px;
    font-size: 14px;
    width: 100%;

    &:focus {
      outline: none;
      border-color: variables.$blue;
    }
  }
}

.error {
  color: variables.$red;
  font-size: 0.875rem; // f6 equivalent
  display: block;
  padding-top: 0.5rem;
  line-height: 1.5;
  margin: 0;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px solid variables.$light-gray;
}

.closeButton,
.applyButton {
  padding: 6px 16px;
  background-color: variables.$white;
  border: 1px solid variables.$moon-gray;
  border-radius: 3px;
  color: variables.$near-black;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: variables.$light-gray;
  }

  &:active {
    transform: translateY(1px);
  }
}

.applyButton {
  background-color: variables.$blue;
  color: variables.$white;
  border-color: variables.$blue;

  &:hover {
    background-color: variables.$dark-blue;
  }
}
